import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import ProductCard from './ProductCard';
import '../styles/CategoryCarousel.css';

const CategoryCarousel = ({ category, products }) => {
  const carouselRef = useRef(null);

  const scroll = (direction) => {
    if (carouselRef.current) {
      const scrollAmount = 320; // Ancho de tarjeta + gap
      const newScrollPosition = carouselRef.current.scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount);
      
      carouselRef.current.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth'
      });
    }
  };

  if (!products || products.length === 0) {
    return null;
  }

  return (
    <div className="category-carousel">
      <div className="category-carousel-header">
        <div className="category-info">
          <h2 className="category-carousel-title">{category}</h2>
        </div>
        <Link 
          to={`/catalogo?categoria=${encodeURIComponent(category)}`}
          className="btn btn-secondary btn-view-all"
        >
          Ver todos
          <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </Link>
      </div>

      <div className="carousel-container">
        <button 
          className="carousel-button carousel-button-left"
          onClick={() => scroll('left')}
          aria-label="Anterior"
        >
          <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <div className="carousel-track" ref={carouselRef}>
          {products.map((product) => (
            <div key={product.id} className="carousel-item">
              <ProductCard product={product} />
            </div>
          ))}
        </div>

        <button 
          className="carousel-button carousel-button-right"
          onClick={() => scroll('right')}
          aria-label="Siguiente"
        >
          <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      {/* Botón "Ver todos" para móvil - debajo del carrusel */}
      <div className="category-carousel-footer">
        <Link 
          to={`/catalogo?categoria=${encodeURIComponent(category)}`}
          className="btn btn-secondary btn-view-all-mobile"
        >
          Ver todos
          <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default CategoryCarousel;

